var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRainDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1834 81.9112C19.275 81.9112 8 70.6362 8 56.7278C8 42.8194 19.275 31.5444 33.1834 31.5444C36.1992 31.5444 39.0912 32.0745 41.7712 33.0466C47.059 20.1128 59.767 11 74.6035 11C94.1851 11 110.059 26.874 110.059 46.4556C110.059 47.3182 110.028 48.1737 109.968 49.0208C115.889 51.7474 120 57.7339 120 64.6805C120 74.1968 112.286 81.9112 102.769 81.9112H33.1834Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9542 95.7094L89.5147 88.5385L86.0751 95.7096C85.7339 96.3071 85.5384 97.0018 85.5384 97.7429C85.5384 99.9797 87.3187 101.793 89.5147 101.793C91.7108 101.793 93.4911 99.9797 93.4911 97.7429C93.4911 97.0017 93.2956 96.307 92.9542 95.7094Z",
    fill: "#25A8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0254 110.29L77.5858 103.118L74.1464 110.289C73.805 110.887 73.6094 111.581 73.6094 112.323C73.6094 114.56 75.3897 116.373 77.5857 116.373C79.7818 116.373 81.5621 114.56 81.5621 112.323C81.5621 111.582 81.3666 110.887 81.0254 110.29Z",
    fill: "#25A8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0963 95.7095L65.6568 88.5385L62.2173 95.7094C61.8759 96.307 61.6804 97.0017 61.6804 97.7429C61.6804 99.9797 63.4607 101.793 65.6567 101.793C67.8528 101.793 69.6331 99.9797 69.6331 97.7429C69.6331 97.0018 69.4376 96.3071 69.0963 95.7095Z",
    fill: "#25A8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8299 110.289L54.3905 103.118L50.9509 110.289C50.6096 110.887 50.4141 111.582 50.4141 112.323C50.4141 114.56 52.1944 116.373 54.3905 116.373C56.5865 116.373 58.3668 114.56 58.3668 112.323C58.3668 111.582 58.1713 110.887 57.8299 110.289Z",
    fill: "#25A8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9012 95.7097L42.4615 88.5385L39.0221 95.7092C38.6807 96.3069 38.4851 97.0016 38.4851 97.7429C38.4851 99.9797 40.2654 101.793 42.4615 101.793C44.6575 101.793 46.4378 99.9797 46.4378 97.7429C46.4378 97.0018 46.2424 96.3073 45.9012 95.7097Z",
    fill: "#25A8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.972 110.289L30.5325 103.118L27.093 110.289C26.7516 110.887 26.5562 111.582 26.5562 112.323C26.5562 114.56 28.3364 116.373 30.5325 116.373C32.7286 116.373 34.5088 114.56 34.5088 112.323C34.5088 111.582 34.3133 110.887 33.972 110.289Z",
    fill: "#25A8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainDm);
export default __webpack_public_path__ + "static/media/rain-dm.d828b219ac416bae191c2723486d103b.svg";
export { ForwardRef as ReactComponent };